import { useRef } from "react";
import { motion, useInView } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

/* Masked line-by-line reveal. Pass an array of strings as `lines`. */
export function RevealLines({ lines = [], className = "", delay = 0, stagger = 0.09 }) {
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden">
          <motion.span
            className="block"
            initial={{ y: "115%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1.05, ease: EASE, delay: delay + i * stagger }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}

/* Scroll-triggered fade + rise for any block. */
export function FadeUp({ children, className = "", delay = 0, y = 34, once = true, ...rest }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-60px" }}
      transition={{ duration: 0.85, ease: EASE, delay }}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

/* Reveal wrapper for images: subtle zoom + fade. Uses useInView (reliable on
   mobile) instead of an animated clip-path, which failed to un-clip on touch
   devices and left images blank. */
export function ClipReveal({ children, className = "" }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.15 });
  return (
    <div ref={ref} className={className}>
      <motion.div
        initial={{ opacity: 0, scale: 1.06 }}
        animate={inView ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 1.06 }}
        transition={{ duration: 1.0, ease: EASE }}
        style={{ height: "100%" }}
      >
        {children}
      </motion.div>
    </div>
  );
}
